

import templateCartPage from '@/app-template/lib/pages/CartPage.vue';

export default {
  name: "CartPage",
  components: { templateCartPage },
};
